import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { environment } from '../../../environments/environment';
import { MessageService } from 'primeng/api';
import { ApiService } from '../../services/api.service';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { FileUpload } from 'primeng/fileupload';

@Component({
  selector: 'app-dpr-submission',
  standalone: false,
  templateUrl: './dpr-submission.component.html',
})
export class DprSubmissionComponent implements OnInit {
  @Input() stepDetails: any;
  @Input() urls: {getUrl:string,evalUrl:string,vUrl:string};
  @Input() projectName:string
  @Input() schemeType: any;
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  payload: any;
  winners:any

  constructor(private fb: FormBuilder, private messageService: MessageService, private api: ApiService, private route: ActivatedRoute) {
       
   }

  ngOnInit(): void {

    this.getRfpDetails()
  }
  getRfpDetails() {
    this.api.getAPI(`${this.urls.getUrl}?proposal_step=${this.stepDetails.id}&proposal_step__proposal=${this.stepDetails.proposal}`).subscribe((res: any) => {
      const vendorMap = res?.vender || res?.vendor || {};
       this.winners = Object.values(vendorMap).flat();
    });
  }

  setStatus(vendor: any, status: 'Qualify' | 'Disqualify') {
    const formData = new FormData();
    formData.append('vendor_status', status);
    formData.append('id', vendor.id);
    this.api.putAPI(this.urls.evalUrl, formData).subscribe(res=>{
      vendor.vendor_status = status;
          this.messageService.add({  severity: 'success',  summary: 'Success',    detail: res.message || 'Vendor updated successfully',      });
          this.getRfpDetails();
        });
      }

}
